import React from "react";
import { connect } from "react-redux";
import * as actions from "../../../actions/actions";
import classNames from "classnames";

import ProcessButton from "../../../legacy/components/processbutton";
import FacebookLoginLink from "../facebook-login-link";

class LoginForm extends React.Component {
    state = {
        success: false
    };

    componentWillMount() {
        this.props.authFormClearErrors();
        this.props.authFormClearData();
    }

    formHasErrors = () => {
        return (
            this.props.error || Object.keys(this.props.fieldErrors).length > 0
        );
    };

    logIn = e => {
        e.preventDefault();

        this.props
            .logIn()
            .then(this.onSuccess)
            .catch(() => null);
    };

    handleFocus = () => {
        if (this.formHasErrors()) {
            this.props.authFormClearErrors();
        }
    };

    handleLoginInputChange = e =>
        this.props.authFormInputChange({ login: e.target.value });

    handlePasswordInputChange = e =>
        this.props.authFormInputChange({ password: e.target.value });

    onSuccess = () => {
        this.setState({ success: true });

        if (this.props.onSuccess) {
            this.props.onSuccess();
            return;
        }

        this.props.redirect(this.props.next);
    };

    handleSignupLinkClick = e => {
        if (this.props.showSignup) {
            e.preventDefault();
            this.props.showSignup();
        }
    };

    render() {
        const { fieldErrors, authPathOverride } = this.props;
        let { loginFieldError, passwordFieldError } = fieldErrors;

        let status;

        if (this.state.success) status = "success";
        if (this.formHasErrors()) status = "failure";
        if (this.props.processing) status = "processing";

        let authPath = authPathOverride || "/accounts/signup/";

        return (
            <React.Fragment>
                <div id="form-container">
                    <form
                        id="login-form"
                        data-test="login-form"
                        className="new-form dark-form form-pro"
                        onSubmit={this.logIn}
                    >
                        <ol>
                            <li>
                                <input
                                    id="user_id"
                                    className={classNames({
                                        "error on": loginFieldError
                                    })}
                                    maxLength="254"
                                    name="login"
                                    type="text"
                                    required
                                    placeholder="Email Address"
                                    value={this.props.login}
                                    onChange={this.handleLoginInputChange}
                                    onFocus={this.handleFocus}
                                    data-test="login-form-login-input"
                                />

                                <label
                                    htmlFor="user_id"
                                    className={classNames("show", {
                                        "error on": loginFieldError
                                    })}
                                >
                                    {loginFieldError
                                        ? loginFieldError
                                        : "Email"}
                                </label>
                                <label
                                    htmlFor="user_id"
                                    className="ui_icon ui_user"
                                />
                            </li>

                            <li>
                                <input
                                    id="id_password"
                                    maxLength="4096"
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    className={classNames({
                                        "error on": passwordFieldError
                                    })}
                                    required
                                    value={this.props.password}
                                    onChange={this.handlePasswordInputChange}
                                    onFocus={this.handleFocus}
                                    data-test="login-form-password-input"
                                />

                                <label
                                    htmlFor="id_password"
                                    className={classNames("show", {
                                        "error on": passwordFieldError
                                    })}
                                >
                                    {passwordFieldError
                                        ? passwordFieldError
                                        : "Password"}
                                </label>
                                <label
                                    htmlFor="id_password"
                                    className="ui_icon ui_lock"
                                />
                            </li>
                        </ol>
                        <ProcessButton
                            buttonState={status}
                            buttonText="Log In"
                            iconClass="ui_key"
                            extraClass="full-width"
                            color={this.props.submitButtonColor}
                        />
                        <div className="error on">{this.props.error}</div>
                        {this.props.showFacebookLoginLink ? (
                            <FacebookLoginLink error={this.props.error} />
                        ) : null}
                    </form>
                </div>
                <div>
                    <a
                        className="forgot-password text-link"
                        href="/accounts/password/reset/"
                    >
                        Forgot your password?
                    </a>
                    <br />
                    <a
                        className="text-link"
                        data-test="signup-page-link"
                        href={`${authPath}${
                            this.props.next ? `?next=${this.props.next}` : ``
                        }`}
                        onClick={this.handleSignupLinkClick}
                    >
                        New? Create a free account
                    </a>
                </div>
            </React.Fragment>
        );
    }
}

LoginForm.defaultProps = {
    next: "/"
};

const mapStateToProps = state => {
    const { auth } = state;

    return {
        error: auth.error,
        fieldErrors: auth.fieldErrors,
        login: auth.login,
        password: auth.password,
        processing: auth.processing
    };
};

export default connect(mapStateToProps, {
    logIn: actions.logIn,
    authFormInputChange: actions.authFormInputChange,
    authFormClearErrors: actions.authFormClearErrors,
    redirect: actions.redirect,
    authFormClearData: actions.authFormClearData
})(LoginForm);
